module.exports = __webpack_public_path__ + "img/SKMJ_drill2.74c3841f.jpg";